import { allBlockchainCoin } from '@/assets/static/currency-list'

const ACTIVE_BLOCKCHAIN_KEY = 'dashboard-active-blockchain'
const RANGE_FILTER_KEY = 'dashboard-range-filter'

const getFromLocalStorage = (key, fallback) => {
  try {
    const value = localStorage.getItem(key)

    return value ? JSON.parse(value) : fallback
  } catch {
    return fallback
  }
}

export default {
  activeBlockchain: getFromLocalStorage(ACTIVE_BLOCKCHAIN_KEY, allBlockchainCoin),
  rangeFilter: getFromLocalStorage(RANGE_FILTER_KEY, null),
}